import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag2Sparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBag2Sparkle"><Path d="M11.5 21.5H4L6 7.5H18L18.6429 12" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 7.5V6C15.5 4.067 13.933 2.5 12 2.5C10.067 2.5 8.5 4.067 8.5 6V7.5" stroke="currentColor" strokeLinecap="square"/><Path d="M18.4 15H17.6L16.6 17.6L14 18.6V19.4L16.6 20.4L17.6 23H18.4L19.4 20.4L22 19.4V18.6L19.4 17.6L18.4 15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBag2Sparkle;
